export const formatCreationDate = (date: string): string => {
    const dateObj = new Date(date);
    
    if (isNaN(dateObj.getTime())) {
        return '';
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
};